import CalendarIcon from "../../../images/icons/sideBar/calendarIcon";
import FavorisIcon from "../../../images/icons/sideBar/favoriIcon";
import HomeIcon from "../../../images/icons/sideBar/homeIcon";
import InterventionIcon from "../../../images/icons/sideBar/InterventionIcon";

export const MenuListClient = [
  {
    title: "Mes Annonces",
    titleKey: "navMyOffers",
    iconStyle: <i className="fi fi-rr-home flex items-center "></i>,
    activeIcon: <i className="fi fi-sr-home flex items-center"></i>,
    to: "",
  },
  {
    title: "Prestataires",
    titleKey: "navProviders",
    iconStyle: <i className="fi fi-rr-search flex items-center"></i>,
    activeIcon: (
      <i className="fi fi-rr-magnifying-glass-wave flex items-center"></i>
    ),
    to: "prestataires",
  },

  {
    title: "Créer une",
    titleSecond: "Annonce",
    titleKey: "navCreatePost",
    iconStyle: <i className="fi fi-rr-add flex items-center"></i>,
    activeIcon: <i className="fi fi-sr-add flex items-center"></i>,
    to: "deposer-une-annonce",
    condition: true,
  },
  {
    title: "Mes Interventions",
    titleKey: "navMyInterventions",
    iconStyle: <i className="fi fi-rr-rectangle-list flex items-center "></i>,
    activeIcon: <i className="fi fi-sr-rectangle-list flex items-center"></i>,
    to: "interventions",
  },
  {
    title: "Messagerie",
    titleKey: "navMessaging",
    iconStyle: <i className="fi fi-rr-paper-plane flex items-center "></i>,
    activeIcon: <i className="fi fi-sr-paper-plane flex items-center"></i>,
    to: "messages",
  },
];

export const MenuList = [
  //Dashboard
  {
    title: "Fil d’annonces",
    titleKey: "navOffersFeed",
    // classsChange: "mm-collapse",
    iconStyle: <i className="fi fi-rr-home flex items-center "></i>,
    activeIcon: <i className="fi fi-sr-home flex items-center"></i>,
    to: "",
  },
  {
    title: "Mes Interventions",
    titleKey: "navMyInterventions",
    iconStyle: <i className="fi fi-rr-rectangle-list flex items-center "></i>,
    activeIcon: <i className="fi fi-sr-rectangle-list flex items-center"></i>,
    to: "interventions",
  },
  {
    title: "Messagerie",
    titleKey: "navMessaging",
    iconStyle: <i className="fi fi-rr-paper-plane flex items-center "></i>,
    activeIcon: <i className="fi fi-sr-paper-plane flex items-center"></i>,
    to: "messages",
  },
  {
    title: "Mes Favoris",
    titleKey: "navFavorites",
    iconStyle: <i className="fi fi-rr-star flex items-center "></i>,
    activeIcon: <i className="fi fi-sr-star flex items-center"></i>,
    to: "favoris",
  },

  // //Apps
  // {
  //   title: "Apps",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-television" />,
  //   content: [
  //     {
  //       title: "Profile",
  //       to: "app-profile",
  //     },

  //     {
  //       title: "Post Details",
  //       to: "post-details",
  //     },
  //     {
  //       title: "Email",
  //       //to: './',
  //       hasMenu: true,
  //       content: [
  //         {
  //           title: "Compose",
  //           to: "email-compose",
  //         },
  //         {
  //           title: "Index",
  //           to: "email-inbox",
  //         },
  //         {
  //           title: "Read",
  //           to: "email-read",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Calendar",
  //       to: "app-calender",
  //     },
  //     {
  //       title: "Shop",
  //       //to: './',
  //       hasMenu: true,
  //       content: [
  //         {
  //           title: "Product Grid",
  //           to: "ecom-product-grid",
  //         },
  //         {
  //           title: "Product List",
  //           to: "ecom-product-list",
  //         },
  //         {
  //           title: "Product Details",
  //           to: "ecom-product-detail",
  //         },
  //         {
  //           title: "Order",
  //           to: "ecom-product-order",
  //         },
  //         {
  //           title: "Checkout",
  //           to: "ecom-checkout",
  //         },
  //         {
  //           title: "Invoice",
  //           to: "ecom-invoice",
  //         },
  //         {
  //           title: "Customers",
  //           to: "ecom-customers",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // //Charts
  // {
  //   title: "Charts",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-controls-3" />,
  //   content: [
  //     {
  //       title: "RechartJs",
  //       to: "chart-rechart",
  //     },
  //     {
  //       title: "Chartjs",
  //       to: "chart-chartjs",
  //     },
  //     {
  //       title: "Sparkline",
  //       to: "chart-sparkline",
  //     },
  //     {
  //       title: "Apexchart",
  //       to: "chart-apexchart",
  //     },
  //   ],
  // },
  // //Boosttrap
  // {
  //   title: "Bootstrap",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-internet" />,
  //   content: [
  //     {
  //       title: "Accordion",
  //       to: "ui-accordion",
  //     },
  //     {
  //       title: "Alert",
  //       to: "ui-alert",
  //     },
  //     {
  //       title: "Badge",
  //       to: "ui-badge",
  //     },
  //     {
  //       title: "Button",
  //       to: "ui-button",
  //     },
  //     {
  //       title: "Modal",
  //       to: "ui-modal",
  //     },
  //     {
  //       title: "Button Group",
  //       to: "ui-button-group",
  //     },
  //     {
  //       title: "List Group",
  //       to: "ui-list-group",
  //     },
  //     {
  //       title: "Cards",
  //       to: "ui-card",
  //     },
  //     {
  //       title: "Carousel",
  //       to: "ui-carousel",
  //     },
  //     {
  //       title: "Dropdown",
  //       to: "ui-dropdown",
  //     },
  //     {
  //       title: "Popover",
  //       to: "ui-popover",
  //     },
  //     {
  //       title: "Progressbar",
  //       to: "ui-progressbar",
  //     },
  //     {
  //       title: "Tab",
  //       to: "ui-tab",
  //     },
  //     {
  //       title: "Typography",
  //       to: "ui-typography",
  //     },
  //     {
  //       title: "Pagination",
  //       to: "ui-pagination",
  //     },
  //     {
  //       title: "Grid",
  //       to: "ui-grid",
  //     },
  //   ],
  // },
  // //plugins
  // {
  //   title: "Plugins",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-heart" />,
  //   content: [
  //     {
  //       title: "Select 2",
  //       to: "uc-select2",
  //     },
  //     // {
  //     //     title:'Noui Slider',
  //     //     to: 'uc-noui-slider',
  //     // },
  //     {
  //       title: "Sweet Alert",
  //       to: "uc-sweetalert",
  //     },
  //     {
  //       title: "Toastr",
  //       to: "uc-toastr",
  //     },
  //     {
  //       title: "Jqv Map",
  //       to: "map-jqvmap",
  //     },
  //     {
  //       title: "Light Gallery",
  //       to: "uc-lightgallery",
  //     },
  //   ],
  // },
  // //Widget
  // {
  //   title: "Widget",
  //   //classsChange: 'mm-collapse',
  //   iconStyle: <i className="flaticon-381-settings-2" />,
  //   to: "widget-basic",
  // },
  // //Forms
  // {
  //   title: "Forms",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-notepad" />,
  //   content: [
  //     {
  //       title: "Form Elements",
  //       to: "form-element",
  //     },
  //     {
  //       title: "Wizard",
  //       to: "form-wizard",
  //     },
  //     {
  //       title: "CkEditor",
  //       to: "form-ckeditor",
  //     },
  //     {
  //       title: "Pickers",
  //       to: "form-pickers",
  //     },
  //     {
  //       title: "Form Validate",
  //       to: "form-validation",
  //     },
  //   ],
  // },
  // //Table
  // {
  //   title: "Table",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-network" />,
  //   content: [
  //     {
  //       title: "Table Filtering",
  //       to: "table-filtering",
  //     },
  //     {
  //       title: "Table Sorting",
  //       to: "table-sorting",
  //     },
  //     {
  //       title: "Bootstrap",
  //       to: "table-bootstrap-basic",
  //     },
  //   ],
  // },
  // //Pages
  // {
  //   title: "Pages",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="flaticon-381-layer-1" />,
  //   content: [
  //     {
  //       title: "Error",
  //       hasMenu: true,
  //       content: [
  //         {
  //           title: "Error 400",
  //           to: "erreur-400",
  //         },
  //         {
  //           title: "Error 403",
  //           to: "erreur-403",
  //         },
  //         {
  //           title: "Error 404",
  //           to: "erreur-404",
  //         },
  //         {
  //           title: "Error 500",
  //           to: "erreur-500",
  //         },
  //         {
  //           title: "Error 503",
  //           to: "erreur-503",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Lock Screen",
  //       to: "page-lock-screen",
  //     },
  //   ],
  // },
];
